import actions from '@ion/api/audit-logs/actions';
import { METATAGGER_AUDIT_LABELS } from 'ion-experimental/app/metatagger/auditActions';
import invert from 'lodash/invert';

export const ACTION_TO_READABLE_ACTION = {
  [actions.ajs_file_built]: 'A.js File Built',
  [actions.ajs_file_uploaded]: 'A.js File Uploaded',
  [actions.auth_logged_in]: 'Logged In',
  [actions.auth_logged_out]: 'Logged Out',
  [actions.consent_category_created]: 'Consent Category Created',
  [actions.consent_category_deleted]: 'Consent Category Deleted',
  [actions.consent_category_updated]: 'Consent Category Updated',
  [actions.event_name_created]: 'Event Created',
  [actions.event_name_deleted]: 'Event Deleted',
  [actions.event_name_updated]: 'Event Updated',
  [actions.event_schema_created]: 'Event Schema Created',
  [actions.event_schema_updated]: 'Event Schema Updated',
  [actions.event_schema_deleted]: 'Event Schema Deleted',
  [actions.integration_added_to_pipeline]: 'Integration Added',
  [actions.integration_created]: 'Integration Created',
  [actions.integration_deleted]: 'Integration Deleted',
  [actions.integration_removed_from_pipeline]: 'Integration Removed',
  [actions.integration_revision_created]: 'Revision Created',
  [actions.integration_revision_disabled]: 'Revision Disabled',
  [actions.integration_revision_enabled]: 'Revision Enabled',
  [actions.integration_updated]: 'Integration Updated',
  [actions.pipeline_tag_added_to_pipeline]: 'Pipeline Tag Added',
  [actions.pipeline_tag_created]: 'Pipeline Tag Created',
  [actions.pipeline_tag_deleted]: 'Pipeline Tag Deleted',
  [actions.pipeline_tag_removed_from_pipeline]: 'Pipeline Tag Removed',
  [actions.pipeline_tag_updated]: 'Pipeline Tag Updated',
  [actions.pipeline_created]: 'Pipeline Created',
  [actions.pipeline_deployed]: 'Pipeline Deployed',
  [actions.pipeline_deleted]: 'Pipeline Deleted',
  [actions.pipeline_integration_updated]: 'Pipeline Integration Updated',
  [actions.pipeline_updated]: 'Pipeline Updated',
  [actions.pipeline_variable_updated]: 'Pipeline Variable Updated',
  [actions.sample_event_created]: 'Sample Event Created',
  [actions.sample_event_updated]: 'Sample Event Updated',
  [actions.sample_event_deleted]: 'Sample Event Deleted',
  [actions.schema_created]: 'Schema Created',
  [actions.schema_deleted]: 'Schema Deleted',
  [actions.schema_updated]: 'Schema Updated',
  [actions.schema_library_created]: 'Schema Library Created',
  [actions.schema_library_updated]: 'Schema Library Updated',
  [actions.schema_library_deleted]: 'Schema Library Deleted',
  [actions.schema_library_published]: 'Schema Library Published',
  [actions.schema_library_added_to_pipeline]: 'Schema Library Added',
  [actions.schema_library_removed_from_pipeline]: 'Schema Library Removed',
  [actions.standalone_sync_file_built]: 'Standalone Sync File Built',
  [actions.user_deleted]: 'User Deleted',
  [actions.user_invited]: 'User Invited',
  [actions.user_role_edited]: 'User Role Edited',
  ...METATAGGER_AUDIT_LABELS,
};

export const READABLE_ACTION_TO_ACTION = invert(ACTION_TO_READABLE_ACTION);

export const READABLE_ACTIONS = Object.values(ACTION_TO_READABLE_ACTION);

export function readableAction(action) {
  return ACTION_TO_READABLE_ACTION[action];
}
